// extracted by mini-css-extract-plugin
module.exports = {"offer":"OfferItem_offer__LNmLJ","iconHolder":"OfferItem_iconHolder__QXXnJ","texts":"OfferItem_texts__aC0p9"};